import { MeetingResponse } from 'api/meedioBackend/types';

/**
 * True when a scheduled meeting was started before its scheduled time
 * ("Start meeting now" pressed early). `scheduled_at`/`ends_at` always hold the
 * ORIGINAL schedule and are never rewritten on early start, so the actual start
 * time in `started_at` is the only signal that the meeting ran ahead of schedule.
 */
export const wasMeetingStartedEarly = (meeting: MeetingResponse): boolean =>
  meeting.started_at !== null &&
  meeting.scheduled_at !== null &&
  new Date(meeting.started_at) < new Date(meeting.scheduled_at);
